/**
 * AiqKeypad — AIQ fill_blank 하단 커스텀 숫자 키패드.
 * quebon-aiq-mkt modules/input-pad.tsx 포팅: 숫자 + PREV/NEXT(빈칸 이동).
 * 모바일에서 시스템 키보드 대신 노출(빈칸을 비-input으로 렌더하는 호출부와 함께 동작).
 * assessmentMode 하단 '다음' 버튼(bottom-0) 위(bottom-16)에 스택된다.
 */
interface AiqKeypadProps {
  /** 숫자 키 입력(한 자리). 호출부 핸들러가 replace + 자동이동을 처리한다. */
  onInput: (value: string) => void
  onPrev: () => void
  onNext: () => void
  canPrev: boolean
  canNext: boolean
  disabled?: boolean
}

const KEYS: Array<number | 'PREV' | 'NEXT'> = [1, 2, 3, 4, 5, 6, 7, 8, 9, 'PREV', 0, 'NEXT']

export function AiqKeypad({ onInput, onPrev, onNext, canPrev, canNext, disabled = false }: AiqKeypadProps) {
  return (
    <div className="fixed bottom-14 left-1/2 z-40 w-full max-w-[720px] -translate-x-1/2 border-t border-[#eceff5] bg-white px-3 py-4 [box-shadow:0px_-4px_4px_0px_rgb(0_0_0/0.05)]">
      <div className="grid grid-cols-3 gap-2">
        {KEYS.map((k, i) => {
          if (k === 'PREV' || k === 'NEXT') {
            const isPrev = k === 'PREV'
            const enabled = isPrev ? canPrev : canNext
            return (
              <button
                key={`nav-${i}`}
                type="button"
                disabled={disabled || !enabled}
                onClick={isPrev ? onPrev : onNext}
                aria-label={isPrev ? '이전 빈칸' : '다음 빈칸'}
                className="flex h-12 items-center justify-center rounded-lg bg-lc-v3-gray-100 text-lc-text-secondary transition-colors active:bg-lc-key-50 active:text-lc-key-500 disabled:opacity-30"
              >
                <span aria-hidden="true" className="text-lc-v3-h5 font-semibold">{isPrev ? '<' : '>'}</span>
              </button>
            )
          }
          return (
            <button
              key={`key-${k}`}
              type="button"
              disabled={disabled}
              onClick={() => onInput(String(k))}
              className="h-12 rounded-lg bg-lc-v3-gray-100 text-lc-v3-h5 font-semibold text-lc-text-secondary transition-colors active:bg-lc-key-50 active:text-lc-key-500 disabled:opacity-50"
            >
              {k}
            </button>
          )
        })}
      </div>
    </div>
  )
}
